import { ViewModel,View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { PersonnelSelectorViewModel } from "src/EnterpriseAdministration/personnelManipulation/personnelSelector";
import { PersonnelSearchableSelectorViewModel } from "src/EnterpriseAdministration/personnelManipulation/personnelSelector";
import { SendToLocalNotificationMessage } from "src/server/localNotification";
import { ServerConnection } from "src/server/serverConnection";
import  { DeliveryCartableCollectorView } from "./deliveryCartableCollector-view"
import { PrintDeliveryFormAction } from "../deliveryCartableDetail/deliveryCartableDetail-viewModel";

export class DeliveryCartableCollectorViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ViewModel, invoiceId: string, warehousePartId:string, collectorId:string, warehouseId: string) {
        super(parentViewModel);
        this.invoiceId = invoiceId;
        this.warehousePartId = warehousePartId;
        this.personnelSelector = new PersonnelSelectorViewModel(this, false, warehouseId, false, true, false, false, false);
        this.personnelSelector.onSelectionChanged = q=>{
            this.personnelName = q.title;
        }
        this.personnelSelector.refresh()
        this._serverUpdater = new UpdateServerUpdater();
        this.setPersonnel(collectorId);
    }
    GetDefaultView(): View <ViewModel> {
        return new DeliveryCartableCollectorView();
    }
    public getTypeId(): string {
        return "VM-D6D5FB50-5A30-4B85-B137-6DD4985AF5F2"
    }

    private _serverUpdater:IServerUpdater;
    
    public set invoiceId(v: string) { this._invoiceId = v; } public get invoiceId(): string { return this._invoiceId; } private _invoiceId: string;
    public set warehousePartId(v: string) { this._warehousePartId = v; } public get warehousePartId(): string { return this._warehousePartId;} private _warehousePartId: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set personnelSelector(v: PersonnelSelectorViewModel) { this._personnelSelector = v; } public get personnelSelector(): PersonnelSelectorViewModel { return this._personnelSelector;} private _personnelSelector: PersonnelSelectorViewModel;    
    public set personnelName(v: string) { this._personnelName = v; } public get personnelName(): string { return this._personnelName;} private _personnelName: string;
    
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.getPersonnelId())){
            result.push(' پرسنل مشخص نشده است.')
        }
        return result;
    }

    setPersonnel(id: string) {
        this.personnelSelector.selectById(id);
    }

    getPersonnelId() {
        return this.personnelSelector.selectedItem.id;
    }
    
    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت جمع آوری کننده');
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(),'عملیات موفق');
            this.print();
            this.closePopup("done");

        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    async print(){
        new PrintDeliveryFormAction().Print(this, this.invoiceId, this.warehousePartId);
    }

    closePopup(resultCode: string = null) {

    }
}


interface IServerUpdater{
    execute(deliveryCartableCollectorViewModel:DeliveryCartableCollectorViewModel):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'جمع آوری کننده با موفقیت ثبت شد.';
    }
    async execute(deliveryCartableCollectorViewModel: DeliveryCartableCollectorViewModel): Promise<void> {
        await ServerConnection.callServer('/Complex/WarehouseServices/SetCollector',{
            PersonnelId:deliveryCartableCollectorViewModel.getPersonnelId(),
            InvoiceId:deliveryCartableCollectorViewModel.invoiceId,
            InvoiceWarehousePartId:deliveryCartableCollectorViewModel.warehousePartId,
        });
    }
}

class UpdateServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'جمع آوری کننده با موفقیت به روز رسانی شد.';

    }
    async execute(deliveryCartableCollectorViewModel: DeliveryCartableCollectorViewModel): Promise<void> {
        await ServerConnection.callServer('/Complex/WarehouseServices/SetCollector',{
            PersonnelId:deliveryCartableCollectorViewModel.getPersonnelId(),
            InvoiceId:deliveryCartableCollectorViewModel.invoiceId,
            InvoiceWarehousePartId:deliveryCartableCollectorViewModel.warehousePartId,
        });
    }
}

export class PrintCollectionReportAction{
    public async Print(parent:ViewModel, InvoiceId:string, invoiceWarehousePartId:string):Promise<void>{
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/DeliveryCartableDetail',{
            InvoiceId:InvoiceId,
            InvoiceWarehousePartId:invoiceWarehousePartId
        });
        return this.PrintFromDto(parent,result);
    }

    public PrintFromDto(parent:ViewModel, result:any){
        var message = new SendToLocalNotificationMessage("requestPrint",{
            Form:"CollectionReport",
            Data:{
                CopyCount:1,
                SellerName:result.SellerName,
                CustomerName:result.CustomerName,
                CollectorName:result.CollectorName,
                CollectionId:result.InvoiceId,
                FactorCode:result.InvoiceNumber,
                FactorTime:result.CreatedDate,
                SetCollectorTime:result.CollectTime,
                Items:result.LineItems.map((x,i)=>{
                    return {
                        RowIndex:i+1,
                        Code:x.ProductCode,
                        Description:x.ProductName,
                        Number:x.Amount,
                        WarehousePlacement:x.WarehouseLocation,
                        InStockNumber:x.Stock,
                        AvailableBalance:x.AccessibleStock,
                        // InSendProcess:x.amount,
                        // Pnc:x.FinalPrice,
                        // Brand:x.FinalPrice,
                        // Country:x.FinalPrice,
                    };
                })
            }
        });
        return parent.handleMessage(message);
    }
}
